import { AppAction } from "../../../../root/AppAction";
import HeaderEvents from "./HeaderEvents";

export interface HeaderStore {
    from: string;
    to: string;
    direction: string;
    scrollTop: number;
}

const initialStore: HeaderStore = {
    from: "/homepage",
    to: "/homepage",
    direction: "",
    scrollTop: 0
};

export default function header(state: HeaderStore = initialStore, action: AppAction) {
    if (action.type === HeaderEvents.ChangeMenu) {
        return {
            from: action.from,
            to: action.to,
            direction: action.direction
        };
    } 
    // 使っていないので、一旦コメントアウトする
    // else if (action.type === HeaderEvents.OnScroll) {
    //     return {
    //         scrollTop: action.scrollTop
    //     };
    // } 
    else {
        return state;
    }
}
